import { Icon } from '@iconify/react'
import { UtilService } from 'common/services/utilService'
import { EhrSyncIcon } from 'features/Home/Book/Booking/Schedule/PatientSchedule/ScheduleCalendar/EhrSyncIcon'
import type { ITransactionMappingItem } from './transactionsMapping.api'
import styles from './transactionsMapping.module.scss'

export const TRANSACTIONS_MAPPING_TABLE_COLUMNS = [
  {
    title: 'Action',
    dataIndex: 'action',
    key: 'action',
    width: 100,
    render: (
      _: any,
      data: ITransactionMappingItem & {
        type?: string
        onResolveKnownPatient?: (row: ITransactionMappingItem) => void
        appointment_id?: number | null
        patient_id?: number | null
        onResolveWithAppointment?: (row: ITransactionMappingItem) => void
        isResolvingTransaction?: boolean
        resolveError?: string
        onShowEncounters?: (row: ITransactionMappingItem) => void
      },
    ) => {
      const isResolving = !!data.isResolvingTransaction
      const errorIcon = data.resolveError ? (
        <span
          role='button'
          tabIndex={0}
          className={styles.errorIcon}
          onClick={() => data.onShowEncounters?.(data)}>
          <EhrSyncIcon showIcon hideTooltip={false} tooltip={data.resolveError} />
        </span>
      ) : null

      if (data.type === 'transactions_with_appointment') {
        const isDisabled = !data.appointment_id || isResolving
        return (
          <div className={styles.actionCell}>
            <button
              className={styles.actionButton}
              disabled={isDisabled}
              onClick={isDisabled ? undefined : () => data.onResolveWithAppointment?.(data)}
              style={isDisabled ? { opacity: 0.5, cursor: 'not-allowed' } : {}}>
              <span className={styles.actionLabel}>Retry</span>
              <span className={styles.actionIcon}>
                <Icon icon='mdi:refresh' />
              </span>
            </button>
            {errorIcon}
          </div>
        )
      }
      if (data.type === 'transactions_with_known_patient') {
        const isDisabled = !data.patient_id || isResolving
        return (
          <div className={styles.actionCell}>
            <button
              className={styles.actionButton}
              disabled={isDisabled}
              onClick={isDisabled ? undefined : () => data.onResolveKnownPatient?.(data)}
              style={isDisabled ? { opacity: 0.5, cursor: 'not-allowed' } : {}}>
              <span className={styles.actionLabel}>Retry</span>
              <span className={styles.actionIcon}>
                <Icon icon='mdi:refresh' />
              </span>
            </button>
            {errorIcon}
          </div>
        )
      }
      if (data.type === 'transactions_with_new_patient') {
        return (
          <div className={styles.actionCell}>
            <button
              className={styles.actionButton}
              disabled={isResolving}
              onClick={isResolving ? undefined : () => data.onResolveKnownPatient?.(data)}
              style={isResolving ? { opacity: 0.5, cursor: 'not-allowed' } : {}}>
              <span className={styles.actionLabel}>Resolve</span>
              <span className={styles.actionIcon}>
                <Icon icon='mdi:account-plus' />
              </span>
            </button>
            {errorIcon}
          </div>
        )
      }
      return null
    },
  },
  {
    title: 'Patient Name',
    dataIndex: 'patient_name',
    key: 'patient_name',
    type: 'text',
    className: 'table-col-min-width-md',
    editable: false,
    render: (_: string, data: ITransactionMappingItem) => {
      if (data.patient_id) {
        return <p className='navigation-link'>{`${data.pat_fname} ${data.pat_lname}`}</p>
      }
      return `${data.pat_fname} ${data.pat_lname}`
    },
    sorter: true,
  },
  {
    title: 'Transaction ID',
    dataIndex: 'transaction_id',
    key: 'transaction_id',
    type: 'text',
    className: 'table-col-min-width-md',
    editable: false,
    sorter: true,
  },
  {
    title: 'Phone',
    dataIndex: 'pat_phone',
    key: 'pat_phone',
    type: 'text',
    editable: false,
    sorter: true,
  },
  {
    title: 'Amount',
    dataIndex: 'amount',
    key: 'amount',
    type: 'text',
    className: 'table-col-min-width-md',
    editable: false,
    render: (val: String) => UtilService.numberToDollar(Number(val)),
    sorter: true,
  },
  {
    title: 'Created By',
    dataIndex: 'created_by',
    key: 'created_by',
    type: 'text',
    width: 120,
    editable: false,
    sorter: true,
  },
  {
    title: 'Created At',
    dataIndex: 'created_at',
    key: 'created_at',
    type: 'text',
    editable: false,
    sorter: true,
  },
]
